import React from 'react';
import { toast } from 'react-hot-toast';
import DynamicTitle from '../../../Hooks/DynamicTitle';
import { useForm } from "react-hook-form";


const AddService = () => {

    DynamicTitle('AddService');

    const { register, handleSubmit, reset, formState: { errors } } = useForm();
    const handleAddService = (data) => {
        const image = data.image[0];
        const formData = new FormData();
        formData.append('image', image);

        const url = `https://api.imgbb.com/1/upload?expiration=63072000?&key=89ec2a15f5561ad05606277fd8d38f85`
        fetch(url, {
            method: 'POST',
            body: formData
        })
            .then(res => res.json())
            .then(imageData => {
                if (imageData.success) {
                    const service = {
                        service_name: data.service_name,
                        image_url: data.image,
                        details: data.details,
                        packages: {
                            silver: {
                                price: `$${data.silver_price}`
                            },
                            gold: {
                                price: `$${data.gold_price}`
                            },
                            platinum: {
                                price: `$${data.platinum_price}`
                            }
                        }
                    };
                    console.log(service);

                    fetch(`https://lens-king-server.vercel.app/services`, {
                        method: "POST",
                        headers: {
                            "content-type": "application/json"
                        },
                        body: JSON.stringify(service)
                    })
                        .then(res => res.json())
                        .then(data => {
                            if (data.acknowledged) {
                                reset();
                                toast('Your service is successfully added...Thank you.', {
                                    position: "top-center",
                                });
                            }
                        })
                        .catch(err => console.log(err.message));
                }
            })
    }

    // const handleSubmit = (event) => {
    //     event.preventDefault();
    //     const form = event.target;
    //     const name = form.service_name.value;
    //     const details = form.details.value;
    //     const silver = form.silver_price.value;
    //     const gold = form.gold_price.value;
    //     const platinum = form.platinum_price.value;

    //     console.log(`${form.image}`);

    //     // const imageHostKey = '89ec2a15f5561ad05606277fd8d38f85';

    //     const image = form.image.value;
    //     console.log('Image', image)

    //     if (details.length < 200) {
    //         toast('Please give a reasonable comment Please...', {
    //             position: "top-center",
    //         });
    //     } else {
    //         const url = `https://api.imgbb.com/1/upload?expiration=63072000?&key=89ec2a15f5561ad05606277fd8d38f85`
    //         fetch(url, {
    //             method: 'POST',
    //             body: image
    //         })
    //             .then(res => res.json())
    //             .then(imageData => {
    //                 if (imageData.success) {
    //                     setImg(imageData.data.url)
    //                     console.log(imageData.data.url)
    //                 }
    //             })

    //         const service = {
    //             service_name: name,
    //             image_url: img,
    //             details: details,
    //             packages: {
    //                 silver: {
    //                     price: `$${silver}`
    //                 },
    //                 gold: {
    //                     price: `$${gold}`
    //                 },
    //                 platinum: {
    //                     price: `$${platinum}`
    //                 }
    //             }
    //         };
    //         console.log(service);

    //         // fetch(`https://lens-king-server.vercel.app/services`, {
    //         //     method: "POST",
    //         //     headers: {
    //         //         "content-type": "application/json"
    //         //     },
    //         //     body: JSON.stringify(service)
    //         // })
    //         //     .then(res => res.json())
    //         //     .then(data => {
    //         //         if (data.acknowledged) {
    //         //             form.reset();
    //         //             toast('Your service is successfully added...Thank you.', {
    //         //                 position: "top-center",
    //         //             });
    //         //         }
    //         //     })
    //         //     .catch(err => console.log(err.message));
    //     };
    // };

    return (
        <div className="my-10">
            <div className='text-center'>
                <h1 className='text-4xl py-6 lg:text-5xl text-cyan-500 font-bold'>Add Service</h1>
            </div>

            <div className="">
                <div className="">
                    <div className="card shadow-2xl w-[90%] lg:w-[70%] mx-auto bg-base-100">
                        <form onSubmit={handleSubmit(handleAddService)}>

                            {/* Service Name Field  */}
                            <div className="form-control bg-none">
                                <label className="label ">
                                    <span className="label-text ">Service Name</span>
                                </label>
                                <input className="input input-bordered" placeholder='Service Name'
                                    {...register("service_name", { required: "Name Must have 4 or more character.", min: 8, max: 30 })}
                                    aria-invalid={errors.name ? "true" : "false"}
                                />
                                {errors.name && <p className='text-red-500' role="alert">{errors.name?.message}</p>}
                            </div>

                            {/* Service Demo Image File  */}
                            <div className="form-control">
                                <label className="label">
                                    <span className="label-text">Service Image</span>
                                </label>
                                <input className="input input-bordered" placeholder='Choose an image' type='file'
                                    {...register("image", { required: "For some security purpose Image field is required." })}
                                    aria-invalid={errors.image ? "true" : "false"}
                                />
                                {errors.image && <p className='text-red-500' role="alert">{errors.image?.message}</p>}
                            </div>

                            {/* Silver Package Price  */}
                            <div className="form-control">
                                <label className="label">
                                    <span className="label-text">Service Details</span>
                                </label>
                                <input className="input input-bordered" placeholder='Enter Details'
                                    {...register("details", { required: "Email Address is required" })}
                                    aria-invalid={errors.email ? "true" : "false"}
                                />
                                {errors.email && <p className='text-red-500' role="alert">{errors.email?.message}</p>}
                            </div>

                            {/* Gold Package Price  */}
                            <div className="form-control">
                                <label className="label">
                                    <span className="label-text">Silver Package Price</span>
                                </label>
                                <input className="input input-bordered" placeholder='Enter Silver Package Price'
                                    {...register("silver_price", { required: "Email Address is required" })}
                                    aria-invalid={errors.email ? "true" : "false"}
                                />
                                {errors.email && <p className='text-red-500' role="alert">{errors.email?.message}</p>}
                            </div>
                            {/* Details Field  */}
                            <div className="form-control">
                                <label className="label">
                                    <span className="label-text">Gold Package Price</span>
                                </label>
                                <input className="input input-bordered" placeholder='Enter Gold Package Price'
                                    {...register("gold_price", { required: "Email Address is required" })}
                                    aria-invalid={errors.email ? "true" : "false"}
                                />
                                {errors.email && <p className='text-red-500' role="alert">{errors.email?.message}</p>}
                            </div>

                            {/* Platinum Package Price  */}
                            <div className="form-control">
                                <label className="label">
                                    <span className="label-text">Platinum Package Price</span>
                                </label>
                                <input className="input input-bordered" placeholder='Enter Platinum Package Price'
                                    {...register("platinum_price", { required: "Email Address is required" })}
                                    aria-invalid={errors.email ? "true" : "false"}
                                />
                                {errors.email && <p className='text-red-500' role="alert">{errors.email?.message}</p>}
                            </div>
                            <div className="form-control mt-6">
                                <button type='submit' className="btn btn-primary">Add Service</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddService;